import { statusSignals } from "@/mocks/statusAndSecurity";
import SectionHeading from "./SectionHeading";

export default function StatusSection() {
  return (
    <section id="status" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="地址可用性自查"
          title="怎么判断一条地址还能不能用"
          desc="与其靠猜，不如按下面四个信号快速判断。多数情况下，几秒钟就能确定该换哪一条地址。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {statusSignals.map((item) => (
            <article key={item.id} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                  <i className={item.icon}></i>
                </span>
                <h3 className="font-heading font-semibold text-base text-foreground-950">{item.title}</h3>
              </div>
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2.5">
                  <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.good}</p>
                </div>
                <div className="flex items-start gap-2.5">
                  <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center">
                    <i className="ri-close-line text-xs"></i>
                  </span>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.bad}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}